import React from "react";
import App from "./App";
import "./index.css";
import "@arcgis/core/assets/esri/themes/light/main.css";
// import esriConfig from "@arcgis/core/config";
import { ThemeProvider } from "@mui/material/styles";
import reportWebVitals from "./reportWebVitals";
import { lightTheme } from "theme";
import { createRoot } from "react-dom/client";
//import 'react-app-polyfill/stable';

import { Buffer } from "buffer";
window.Buffer = Buffer;

// ArcGIS JS API 4.x does NOT support `disableClientCaching` on MapImageLayer.
// The equivalent control is request cache-busting.
// This interceptor disables cache-busting specifically for MapServer export image requests.
// esriConfig.request.interceptors.push({
//   urls: /\/MapServer\/export/i,
//   before: (params) => {
//     if (!params.requestOptions) params.requestOptions = {};
//     params.requestOptions.cacheBust = false;

//     const query = params.requestOptions.query;
//     if (query && typeof query === "object") {
//       delete query._ts;
//       delete query["request.preventCache"];
//     }

//     try {
//       const url = new URL(params.url, window.location.href);
//       url.searchParams.delete("_ts");
//       url.searchParams.delete("request.preventCache");
//       params.url = url.toString();
//     } catch {
//       // ignore malformed/relative URLs
//     }
//   },
// });

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={lightTheme()}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
